// extracted by mini-css-extract-plugin
module.exports = {"row":"withdraw_row__37yOu","column":"withdraw_column__3WeM7","buttonWrapper":"withdraw_buttonWrapper__lJGn4"};